import { isNil } from 'lodash';
import { isString } from 'lodash/lang';

export const validateFontName = fontName => {
  if (isNil(fontName) || !isString(fontName)) {
    return false;
  }

  return fontName;
};
